class CollapsibleTags extends HTMLElement {
  constructor() {
    super()

    this._seeMoreBtn = this.querySelector('.js-button-see-more')
    this._hiddenTags = this.querySelectorAll('.js-hidden-tags')
  }

  connectedCallback() {
    this._seeMoreBtn.addEventListener('click', this._toggleCollapse.bind(this))
  }

  _toggleCollapse() {
    this._hiddenTags.forEach((tag) => {
      tag.classList.toggle('jc-hidden')
    })
    this._seeMoreBtn.classList.toggle('jc-hidden')
  }
}

if (!customElements.get('collapsible-tags')) {
  customElements.define('collapsible-tags', CollapsibleTags)
}
